import * as constants from '../constants';
import scroll from '../../../common/js/util/scroll';

export default {
    name: "adivare-pagination-bar",
    data() {
        return {
            // custom configuration for navigation bar
            // pagination: [previous button][first page]...[pageNr 1][pageNr 2][pageNr 3][pageNr 4][pageNr 5]...[last page][next button]
            conf: {
                pageNumbers: 5,         // Maximum total page numbers in pagination. Requirement: only use odd numbers
                showNextPrevious: true, // show previous and next buttons
                showFirstPage: true,    // show first page with dots: [first page]...[3][4][5][6][7]
                showLastPage: true,     // show last page with dots:  [3][4][5][6][7]...[last page]
                mobile: {
                    enable: true,       // enable mobile pagination. This is the next and previous button if showNextPrevious is enabled
                    breakpoint: 'md',   // determine breakpoint when mobile version should initialize
                },
            },
            // variables below are not configurable, so leave it as it is
            pageNumbers: [], // page numbers. For example: [4, 5, 6, 7, 8]
            atStart: false,  // pagination at start. When first page is still visible in pagination: [1][2][3][4][5]
            atEnd: false,    // pagination at end. When last page (for example: 82) is still visible in pagination: [78][79][80][81][82]
            enable: true,    // enable pagination
            breakpoints: {   // bootstrap breakpoints. See: https://getbootstrap.com/docs/5.0/layout/breakpoints/
                sm: 576,
                md: 768,
                lg: 992,
                xl: 1200,
            }
        }
    },
    computed: {
        currentPage ()    { return this.$store.state.filters.page },
        houseCount ()     { return this.$store.state.houseCount },
        resultsPerPage () { return this.$store.state.filters.resultsPerPage },
        lastPage()        { return Math.ceil(this.houseCount / this.resultsPerPage) },
        isMobile()        { return window.innerWidth <= this.breakpoints[this.conf.mobile.breakpoint] ?? this.breakpoints['md'] },
    },
    watch: {
        houseCount: {
            immediate: true,
            handler() {
                this.pageNumbers = this.pageNumberRange();
            },
        },
        currentPage: {
            immediate: true,
            handler() {
                this.pageNumbers = this.pageNumberRange();
            },
        }
    },
    methods: {
        pageNumberRange() {
            this.enable = (1 < this.lastPage);

            // single page
            if (false === this.enable) return [];

            // when total pages do not exceed this.conf.pageNumbers: [1...lastPage]
            if (this.conf.pageNumbers >= this.lastPage) {
                this.atStart = this.atEnd = true;

                return Array.from(Array(this.lastPage)).map((e,i) => i + 1)
            }

            // first pages: [1...this.conf.pageNumbers]
            if (this.currentPage <= Math.ceil(this.conf.pageNumbers/2) || this.currentPage > this.lastPage) {
                this.atStart = true;
                this.atEnd = false;

                return Array.from(Array(this.conf.pageNumbers)).map((e,i) => i + 1)
            }

            // last pages: [(lastPage - this.conf.pageNumbers)...lastPage]
            if ((this.lastPage - this.currentPage) < Math.ceil(this.conf.pageNumbers/2)) {
                this.atStart = false;
                this.atEnd = true;

                return Array.from(Array(this.conf.pageNumbers)).map((e,i) => i + 1 + this.lastPage - this.conf.pageNumbers);
            }

            // in between pages
            this.atStart = this.atEnd = false;

            return Array.from(Array(this.conf.pageNumbers)).map((e,i) => i + this.currentPage - Math.floor(this.conf.pageNumbers/2));
        },
        scrollToTop() {
          scroll.toTop();
        },
        updatePage(page) {
            this.$store.commit('updatePage', page);
            this.$store.commit('updateRequest', constants.REQUEST_HOUSES);
            this.scrollToTop();
        }
    }
}
